// API Configuration for deployment
const inferApiBase = () => {
  if (typeof window === "undefined") return "https://api.myalbertai.com";
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:5001";
  if (host.endsWith(".amplifyapp.com")) return "https://api-dev.myalbertai.com";
  return "https://api.myalbertai.com";
};

const resolveApiBase = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    // Force known-good dev API for Amplify previews.
    // This avoids broken env overrides that point to non-routed hosts.
    if (host.endsWith(".amplifyapp.com")) {
      return "https://api-dev.myalbertai.com";
    }
  }
  return (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.NEXT_PUBLIC_API_URL ||
    inferApiBase()
  );
};

const rawApiBase = resolveApiBase();

export const API_BASE = String(rawApiBase).replace(/\/+$/, "");

if (process.env.NODE_ENV === "production" && API_BASE.includes("localhost")) {
  // eslint-disable-next-line no-console
  console.error("❌ Production build is using localhost API:", API_BASE);
}

export const API_URL = `${API_BASE}/api`;

export default API_URL;
